module.exports = __webpack_public_path__ + "static/04-3b81a34aff8e917acbfa41afef72a24b.jpg";